<template>
  <svg class="cart-quantity__icon" width="24" height="24" viewBox="0 0 24 24" :fill="fill" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="#BC2030"/>
    <path d="M11.9223 6.00449L12 6C12.3419 6 12.6237 6.25736 12.6622 6.58892L12.6667 6.66667V11.3333H17.3333C17.6752 11.3333 17.957 11.5907 17.9955 11.9223L18 12C18 12.3419 17.7427 12.6237 17.4111 12.6622L17.3333 12.6667H12.6667V17.3333C12.6667 17.6752 12.4093 17.957 12.0777 17.9955L12 18C11.6581 18 11.3763 17.7427 11.3378 17.4111L11.3333 17.3333V12.6667H6.66667C6.32477 12.6667 6.04299 12.4093 6.00449 12.0777L6 12C6 11.6581 6.25736 11.3763 6.58892 11.3378L6.66667 11.3333H11.3333V6.66667C11.3333 6.32477 11.5907 6.04299 11.9223 6.00449L12 6L11.9223 6.00449Z" fill="white"/>
  </svg>
</template>
<script>
  export default {
    name: 'IconPlus',
    props: {
      fill: {
        type: String,
        default: '#BC2030'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/icons/IconPlus.vue